// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DateFns from "date-fns";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function formatDistance(start, end) {
  var result = Belt_Array.joinWith(Belt_Array.slice(DateFns.formatDuration(DateFns.intervalToDuration({
                                      start: start,
                                      end: end
                                    }), {
                                  format: [
                                    "days",
                                    "hours",
                                    "minutes",
                                    "seconds"
                                  ],
                                  zero: false
                                }).replace(" seconds", "s").replace(" second", "s").replace(" days", "d").replace(" day", "d").replace(" hours", "h").replace(" hour", "h").replace(" minutes", "m").replace(" minute", "m").split(" "), 0, 2), " ", (function (a) {
          return a;
        }));
  var match = result.trim();
  if (match === "") {
    return "now";
  } else {
    return result + " ago";
  }
}

function formatDistanceToNow(start) {
  return formatDistance(start, new Date());
}

export {
  formatDistance ,
  formatDistanceToNow ,
}
/* date-fns Not a pure module */
